export const CARGOS_EMPRESA: string[] = [
    'Gerente o propietario',
    'Representante legal o delegado',
    'Director de area (ventas, advo, tesoreria, operaciones)',
    'Analista de ventas o de mercado',
    'Profesional advo',
    'Profesional de ventas',
    'Contador o delegado',
    'Secretaria general',
    'Auxiliar advo, operativo o de ventas',
    'Otro cargo',
];
